export const adminQueryKeys = {
  tags: {
    list: ["get", "/api/admin/tags"] as const,
  },
  events: {
    list: ["get", "/api/admin/events"] as const,
    detail: ["get", "/api/admin/events/{id}"] as const,
    participantStats: ["get", "/api/admin/events/{id}/participant-stats"] as const,
    participantGroups: ["get", "/api/admin/events/{id}/participant-groups"] as const,
    boats: (eventId: string) => ["get", "/api/admin/events", eventId, "boats"] as const,
  },
  participants: {
    list: ["get", "/api/admin/participants"] as const,
    detail: ["get", "/api/admin/participants/{id}"] as const,
  },
  checkouts: {
    list: ["get", "/api/admin/checkouts"] as const,
    detail: ["get", "/api/admin/checkouts/{id}"] as const,
  },
  payments: {
    list: ["get", "/api/admin/payments"] as const,
  },
  users: {
    list: ["get", "/api/admin/users"] as const,
    detail: ["get", "/api/admin/users/{id}"] as const,
  },
  groups: {
    list: ["get", "/api/admin/groups"] as const,
    detail: ["get", "/api/admin/groups/{id}"] as const,
  },
  publicCheckouts: {
    detail: ["get", "/api/public/checkouts/{checkoutId}"] as const,
  },
} as const;
